import { Lock } from "@mui/icons-material";
import { Box, DialogContent, DialogTitle, ModalDialog, Typography } from "@mui/joy";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import queryClient from "@/core/queryClient";
import { meProfileQuery } from "@/hooks/profile";

import MainMenu from "../components/MainMenu";
import { availableVenuesQuery, useCurrentVenueQuery } from "../hooks/venues";

const Component = () => {
  const { data: currentVenue } = useCurrentVenueQuery();
  return (
    <Box
      sx={{
        minWidth: 200,
        background: "var(--joy-palette-neutral-100)",
        display: "flex",
        flexDirection: "row",
        height: "100dvh",
      }}
    >
      <Box>
        <MainMenu />
      </Box>
      {currentVenue && !currentVenue?.userRole ? (
        <Box
          sx={{
            flex: 1,
            borderRadius: 16,
            background: "var(--joy-palette-neutral-50)",
          }}
        >
          <ModalDialog>
            <DialogTitle>
              <Lock />
              Access Denied
            </DialogTitle>
            <DialogContent>
              To access the Route Manager for {currentVenue.name}, you must be an admin or staff
              member.
              <Typography level="body-sm">
                If you think this is a mistake, please ask an admin to add you as a staff member in
                the app.
              </Typography>
            </DialogContent>
          </ModalDialog>
        </Box>
      ) : null}
      {currentVenue?.userRole || !currentVenue ? (
        <Box
          sx={{
            flex: 1,
            borderRadius: 16,
            background: "var(--joy-palette-neutral-50)",
            overflow: "hidden",
          }}
        >
          <Outlet />
        </Box>
      ) : null}
    </Box>
  );
};

export const Route = createFileRoute("/gym/$venueUuid")({
  loader: () => {
    queryClient.prefetchQuery(meProfileQuery);
    queryClient.prefetchQuery(availableVenuesQuery);
  },
  component: Component,
});
